import React from 'react'
import { connect } from 'react-redux'
import InsuranceActions from '../../Redux/InsuranceRedux'
import Modal from 'react-responsive-modal'
import UpdateTravelPackagePrice from '../../Containers/Insurance/UpdateTravelPackagePrice'
import Toggle from 'react-toggle'

class ViewTravelPrice extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      details: {},
      showModal: null,
      switcher: false,
      id: props.uuid,
      form: {
        start_day: '',
        end_day: '',
        price: '',
        currency_code: 'IDR'
      }
    }
  }

  componentDidMount = () => {
    this._fetchTravelPackageView()
  }

  _fetchTravelPackageView = (event) => {
    if (event) {
      event.preventDefault()
    }
    let data = {
      id: this.state.id
    }
    this.props.viewTravelPackage(data)
  }

  _inputChange = (event, field) => {
    let val = event.target.value
    let form = { ...this.state.form }
    form[field] = val
    this.setState({ form })
  }

  _selectItem = (item, action) => {
    this.setState({ details: item })
    this._toggleModal(action)
  }

  _toggleStatus = (item) => {
    let status = item.status
    status === 0 ? status = 1 : status = 0
    let data = {
      parent_id: this.state.id,
      child_id: item.id,
      form: {
        status
      }
    }
    this.props.switchTravelPackagePrice(data)
    setTimeout(() => {
      this._fetchTravelPackageView()
    }, 250)
  }

  _submit = (event) => {
    event.preventDefault()
    let form = { ...this.state.form }
    let data = {
      id: this.state.id,
      form
    }
    this.props.postTravelPackagePrice(data)
    setTimeout(() => {
      this._fetchTravelPackageView()
    }, 250)
  }

  _toggleModal = (action = null) => {
    this.setState({ showModal: action })
    if (!action) {
      this._fetchTravelPackageView()
    }
  }

  render () {
    const { insurance } = this.props
    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h3 className='title mr-auto'>
            Travel Package Price List
            {
              (insurance.fetching || insurance.processing) &&
              <div className='badge badge-info ml-2'>{ insurance.fetching ? 'Fetching ...' : 'Processing ...' }</div>
            }
          </h3>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Start Day</label>
            </div>
            <div className='col-9'>
              <input type='number' min='1' required placeholder='Insert start day count here' value={this.state.form.start_day} className='form-control' onChange={(event) => this._inputChange(event, 'start_day')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>End Day</label>
            </div>
            <div className='col-9'>
              <input type='number' min='1' required placeholder='Insert end day count here' value={this.state.form.end_day} className='form-control' onChange={(event) => this._inputChange(event, 'end_day')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Price</label>
            </div>
            <div className='col-9'>
              <input type='number' min='1' required placeholder='Insert day package price here' value={this.state.form.price} className='form-control' onChange={(event) => this._inputChange(event, 'price')} />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='submit' className='btn btn-info mb-3'>Add Package <i className='fa fa-plus-square' /></button>
            </div>
          </div>
        </form>
        <div>
          <table className='table table-hover table-striped'>
            <thead>
              <tr>
                <th>Start Day</th>
                <th>End Day</th>
                <th>Price</th>
                <th className='text-center'>Edit</th>
                <th className='text-center'>Status</th>
              </tr>
            </thead>
            <tbody>
              {
                insurance.data_view.map((item, i) => (
                  !item.travel_package_price || item.travel_package_price.length === 0
                    ? <tr key={i}>
                      <td className='text-center' colSpan='5'>No Data</td>
                    </tr>
                    : item.travel_package_price.map((item, i) => (
                      <tr key={i}>
                        <td>{item.start_day}</td>
                        <td>{item.end_day}</td>
                        <td>{item.price}</td>
                        <td className='text-center'>
                          <button className='btn btn-primary' onClick={() => this._selectItem(item, 'edit-travel-package-price')}>
                            <i className='fa fa-edit' />
                          </button>
                        </td>
                        <td className='text-center'>
                          <Toggle checked={item.status === 1} onChange={() => this._toggleStatus(item)} />
                        </td>
                      </tr>
                    ))
                ))
              }
            </tbody>
          </table>
        </div>
        <div className='row'>
          <div className='col-12 text-right'>
            <button className='btn btn-lg btn-secondary' onClick={() => this.props.closeModal()}>Close</button>
          </div>
        </div>

        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'edit-travel-package-price'} onClose={this._toggleModal} closeOnOverlayClick>
          <UpdateTravelPackagePrice closeModal={() => this._toggleModal()} parent_id={this.state.id} detail={this.state.details} />
        </Modal>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  insurance: state.insurance
})

const dispatchToProps = (dispatch) => ({
  viewTravelPackage: (data) => dispatch(InsuranceActions.viewTravelPackageRequest(data)),
  postTravelPackagePrice: (data) => dispatch(InsuranceActions.postTravelPackagePriceRequest(data)),
  switchTravelPackagePrice: (data) => dispatch(InsuranceActions.switchTravelPackagePriceRequest(data))
})

export default connect(stateToProps, dispatchToProps)(ViewTravelPrice)



// WEBPACK FOOTER //
// ./src/Containers/Insurance/ViewTravelPrice.js